import { useRef, useCallback, createContext, ReactNode } from 'react';

import { Metric } from '@atlassian/browser-metrics/types';

import { useMetricSender } from 'src/components/browser-metrics';

export const MetricContext = createContext(() => {});

type Props = {
  metric: Metric;
  children: ReactNode;
};

export const MetricProvider = (props: Props) => {
  const metricSentRef = useRef(false);
  const sendMetric = useMetricSender(props.metric);

  const sendMetricOnce = useCallback(() => {
    if (metricSentRef.current) {
      return;
    }

    sendMetric();
    metricSentRef.current = true;
  }, [sendMetric]);

  return (
    <MetricContext.Provider value={sendMetricOnce}>
      {props.children}
    </MetricContext.Provider>
  );
};
